"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
exports.BooleanClass = {
    '=': (obj, param) => {
        if (obj.name === tokens_1.LiteralTokens.NumberLiteralRange &&
            param.name === tokens_1.LiteralTokens.NumberLiteralRange) {
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: String(obj.start === param.start && obj.end === param.end),
            };
        }
        if (obj.name === tokens_1.LiteralTokens.ArrayLiteral && param.name === tokens_1.LiteralTokens.ArrayLiteral) {
            if (obj.image.length !== param.image.length) {
                return {
                    name: tokens_1.LiteralTokens.BooleanLiteral,
                    image: 'false',
                };
            }
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: String(obj.image.every((x, i) => exports.BooleanClass['='](x, param.image[i]).image === tokens_1.BooleanLiteralTokens.true)),
            };
        }
        if (obj.name !== param.name) {
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: 'false',
            };
        }
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(obj.image === param.image && obj.image !== undefined),
        };
    },
    and: (obj, param) => {
        const boolObj = exports.toBoolean(obj);
        const boolParam = exports.toBoolean(param);
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(boolObj.image === tokens_1.BooleanLiteralTokens.true &&
                boolParam.image === tokens_1.BooleanLiteralTokens.true),
        };
    },
    or: (obj, param) => {
        const boolObj = exports.toBoolean(obj);
        const boolParam = exports.toBoolean(param);
        return {
            name: tokens_1.LiteralTokens.BooleanLiteral,
            image: String(boolObj.image === tokens_1.BooleanLiteralTokens.true ||
                boolParam.image === tokens_1.BooleanLiteralTokens.true),
        };
    },
};
exports.toBoolean = (obj) => {
    switch (obj.name) {
        case tokens_1.LiteralTokens.BooleanLiteral:
            return obj;
        case tokens_1.LiteralTokens.NumberLiteral:
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: String(obj.image > 0),
            };
        case tokens_1.LiteralTokens.StringLiteral:
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: String(obj.image !== ''),
            };
        case tokens_1.LiteralTokens.ArrayLiteral:
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: tokens_1.BooleanLiteralTokens.true,
            };
        case tokens_1.LiteralTokens.NumberLiteralRange:
            return {
                name: tokens_1.LiteralTokens.BooleanLiteral,
                image: tokens_1.BooleanLiteralTokens.true,
            };
        default:
            return {
                name: tokens_1.LiteralTokens.DebugLiteral,
                image: null,
            };
    }
};
